import { decode } from "html-entities";

export const jsonParser = (_json) => {
  let json = {};

  try {
    json = JSON.parse(_json);

    if (json === null) {
      json = {};
    }
  } catch (error) {
    json = {};
  }

  return json;
};

export const decodeHtmlEntities = (label) => {
  let item = label;

  try {
    item = decode(item);
  } catch (error) {
    // console.log('Cannot decode categories');
    return label;
  }

  return item;
};

export const getFrameWindow = (iframe) => {
  let doc;

  if (iframe.contentWindow) {
    return iframe.contentWindow;
  }

  if (iframe.window) {
    return iframe.window;
  }

  if (!doc && iframe.contentDocument) {
    doc = iframe.contentDocument;
  }

  if (!doc && iframe.document) {
    doc = iframe.document;
  }

  if (doc && doc.defaultView) {
    return doc.defaultView;
  }

  if (doc && doc.parentWindow) {
    return doc.parentWindow;
  }

  return undefined;
};

export const runAnimation = (iframe) => {
  if (iframe) {
    const iframe_window = getFrameWindow(iframe);

    if (iframe_window) {
      const iframe_document = iframe.contentDocument
        ? iframe.contentDocument
        : iframe.contentWindow
        ? iframe.contentWindow.document
        : iframe.document;

      var interval;
      interval = setInterval(function () {
        if (
          iframe_document.readyState === 'complete' ||
          iframe_document.readyState === 'interactive'
        ) {
          clearInterval(interval);
          if (typeof iframe_window.runAnimation !== 'undefined') {
            iframe_window.runAnimation();
          }
        }
      }, 500);
    }
  }
};

export const addWidescreen = (iframe) => {
  if (iframe) {
    const iframe_window = getFrameWindow(iframe);

    if (iframe_window) {
      const iframe_document = iframe.contentDocument
        ? iframe.contentDocument
        : iframe.contentWindow
        ? iframe.contentWindow.document
        : iframe.document;

      var interval;
      interval = setInterval(function () {
        if (
          iframe_document.readyState === 'complete' ||
          iframe_document.readyState === 'interactive'
        ) {
          clearInterval(interval);
          iframe_window.document.body.classList.add('widescreen');
        }
      }, 500);
    }
  }
};

export const endAnimation = (iframe) => {
  if (iframe) {
    const iframe_window = getFrameWindow(iframe);

    if (iframe_window) {
      const iframe_document = iframe.contentDocument ? iframe.contentDocument : (iframe.contentWindow ? iframe.contentWindow.document : iframe.document);

      var interval;
      interval  = setInterval(function() {
        if( iframe_document.readyState === 'complete' || iframe_document.readyState === 'interactive' ) {
          clearInterval(interval);
          if( typeof iframe_window.endAnimation !== 'undefined' ) {
            iframe_window.endAnimation();
          } else {
            runAnimation(iframe);
          }
        }
      }, 500);
    }
  }
};


export const iframeClickEvents = (iframe) => {
  if (iframe) {
    const iframe_window = getFrameWindow(iframe);

    if (iframe_window) {
      const iframe_document = iframe.contentDocument
        ? iframe.contentDocument
        : iframe.contentWindow
        ? iframe.contentWindow.document
        : iframe.document;

      var interval;
      interval = setInterval(function () {
        if (
          iframe_document.readyState === 'complete' ||
          iframe_document.readyState === 'interactive'
        ) {
          clearInterval(interval);
          iframe_window.document.addEventListener('click', clickEvents, false);
        }
      }, 500);
    }
  }
};

export const clickEvents = (event) => {
  const link = event?.target?.closest('a');

  if (link && link.href) {
    const href = link.href.toLowerCase();

    if (href.indexOf('gotoslide') > -1 || href.indexOf('reloadslide') > -1 || href.indexOf('opendocument') > -1 || href.indexOf('openexternal') > -1 || href.indexOf('openViewerMenu') > -1) {
      event.stopPropagation();
      event.preventDefault();

      if (href.indexOf('openexternal') > -1) {
        let linkToOpen = href;
        linkToOpen = linkToOpen.split('link=');
        linkToOpen = linkToOpen[1];
        window.open(linkToOpen);
      }
    }

    return false;
  }
};

export const getThemeJson = (theme_label) => {
  let json = {};

  if (theme_label) {
    json = window.themes[theme_label];

    try {
      json = JSON.parse(json);
    } catch {
      // error
    }
  }

  return json;
};


export const getLayoutIcons = (layout_id, theme_label) => {
  let icons;
  const theme_json = getThemeJson(theme_label);

  theme_json?.layouts.forEach((layout) => {
    if (layout.id === layout_id) {
      icons = layout.icons;
    }
  });

  return icons;
};

export const getLayoutFiles = (layout_id, theme_label) => {
  let files;
  const theme_json = getThemeJson(theme_label);

  theme_json?.layouts.forEach((layout) => {
    if (layout.id === layout_id) {
      files = layout.files;
    }
  });

  return files;
};

export const getThemeBackgrounds = (theme_label) => {
  let colors = [];
  const theme_json = getThemeJson(theme_label);

  if (theme_json?.backgroundColors) {
    colors = theme_json.backgroundColors;
  }

  return colors;
};

export const getParamFromURL = (url, parameter) => {
  const urlParams = new URLSearchParams(url);
  const myParam = urlParams.get(parameter);

  return myParam;
};

export const processObject = (obj) => {
  for (let key in obj) {
    if (typeof obj[key] === "object" && obj[key] !== null) {
      // Recursively process nested objects
      obj[key] = processObject(obj[key]);
    } else if (typeof obj[key] === "string") {
      // Perform operations on string values
      obj[key] = decode_utf8(obj[key]);
    }
  }
  return obj;
};

/**
 * Deprecated use of escape
 */
export const decode_utf8 = (string) => {
  try {
    return decodeURIComponent(escape(string));
  } catch (e) {
    return string;
  }
};

export const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export const processCellStyle = (rowCount, rowIndex, cellCount, cellIndex, block, slideLayoutId) => {
  if (block.data?.styled && slideLayoutId === 'custom') {
    const styled = block.data?.styled;
    const {
      tableStyle,
      backgroundColor,
      secondaryBGColor,
      fontColor,
      fontSize,
      fontWeight,
      firstRowBGColor,
      firstColBGColor,
      firstRowFontColor,
      firstRowFontSize,
      firstRowFontWeight,
      firstColFontColor,
      firstColFontSize,
      firstColFontWeight,
      gridColor,
      gridType,
      horizontalAlign = 'start',
      verticalAlign = 'start',
      firstRowHorizontalAlign = 'start',
      firstRowVerticalAlign = 'start',
      firstColHorizontalAlign = 'start',
      firstColVerticalAlign = 'start',
    } = styled
    let cellStyle = ''
    const addStyle = (styleString) => cellStyle = cellStyle + `${styleString};`;
    const getFontWeight = (fontWeightValue) => (fontWeightValue !== 1 ? fontWeightValue === 0 ? 700 : 300 : '')

    const defaultBgColor = () => {
      if (tableStyle === 0) {
        if (backgroundColor !== '') {
          addStyle(`background-color: ${backgroundColor}`);
        }
      } else if (tableStyle === 1) {
        if (rowIndex % 2 === 0) {
          if (backgroundColor !== '') {
            addStyle(`background-color: ${backgroundColor}`);
          }
        } else {
          if (secondaryBGColor !== '') {
            addStyle(`background-color: ${secondaryBGColor}`);
          }
        }
      } else if (tableStyle === 2) {
        if (cellIndex % 2 === 0) {
          if (backgroundColor !== '') {
            addStyle(`background-color: ${backgroundColor}`);
          }
        } else {
          if (secondaryBGColor !== '') {
            addStyle(`background-color: ${secondaryBGColor}`);
          }
        }
      }
    }
    const defaultFontColor = () => (fontColor !== '' ? addStyle(`color: ${fontColor}`) : '')
    const defaultFontSize = () => (fontSize !== '' ? addStyle(`font-size: ${fontSize}`) : '');
    const defaultFontWeight = () => (fontWeight !== 1 ? addStyle(`font-weight: ${getFontWeight(fontWeight)}`) : '');

    if (rowIndex === 0) {
      // First row styles
      if (firstRowBGColor !== '') {
        addStyle(`background-color: ${firstRowBGColor}`);
      } else {
        if (cellIndex === 0 && firstColBGColor) {
          addStyle(`background-color: ${firstColBGColor}`);
        } else {
          defaultBgColor();
        }
      }
      if (firstRowFontColor !== '') {
        addStyle(`color: ${firstRowFontColor}`);
      } else defaultFontColor();
      if (firstRowFontSize !== '') {
        addStyle(`font-size: ${firstRowFontSize}`);
      } else defaultFontSize();
      if (firstRowFontWeight !== 1) {
        addStyle(`font-weight: ${getFontWeight(firstRowFontWeight)}`);
      } else defaultFontWeight();
      addStyle(`text-align: ${firstRowHorizontalAlign}`);
      addStyle(`justify-content: ${firstRowHorizontalAlign}`);
      addStyle(`align-items: ${firstRowVerticalAlign}`);
    } else if ((rowIndex !== 0) && (cellIndex === 0)) {
      // First column styles
      if (firstColBGColor !== '') {
        addStyle(`background-color: ${firstColBGColor}`);
      } else defaultBgColor();
      if (firstColFontColor !== '') {
        addStyle(`color: ${firstColFontColor}`);
      } else defaultFontColor();
      if (firstColFontSize !== '') {
        addStyle(`font-size: ${firstColFontSize}`);
      } else defaultFontSize();
      if (firstColFontWeight !== 1) {
        addStyle(`font-weight: ${getFontWeight(firstColFontWeight)}`);
      } else defaultFontWeight();
      addStyle(`text-align: ${firstColHorizontalAlign}`);
      addStyle(`justify-content: ${firstColHorizontalAlign}`);
      addStyle(`align-items: ${firstColVerticalAlign}`);
    } else {
      defaultBgColor();
      defaultFontColor();
      defaultFontSize();
      defaultFontWeight();
      addStyle(`text-align: ${horizontalAlign}`);
      addStyle(`justify-content: ${horizontalAlign}`);
      addStyle(`align-items: ${verticalAlign}`);
    }
    const gridStyle = `1px solid ${gridColor}`;
    if (gridType === 1) {
      if (cellIndex === (cellCount - 1)) {
        addStyle(`border-right: ${gridStyle}`);
      }
      if (rowIndex === (rowCount - 1)) {
        addStyle(`border-bottom: ${gridStyle}`);
      }
      addStyle(`border-top: ${gridStyle}`);
      addStyle(`border-left: ${gridStyle}`);
    } else if (gridType === 2) {
      if (rowIndex === 0) {
        addStyle(`border-top: ${gridStyle}`);
        addStyle(`border-bottom: ${gridStyle}`);
      } else {
        addStyle(`border-bottom: ${gridStyle}`);
      }
    } else if (gridType === 3) {
      if (cellIndex === 0) {
        addStyle(`border-left: ${gridStyle}`);
        addStyle(`border-right: ${gridStyle}`);
      } else {
        addStyle(`border-right: ${gridStyle}`);
      }
    }
    return cellStyle;
  } else return '';
}